import { ChevronDown } from "lucide-react";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "./ui/dropdown-menu";

type LessonActionsProps = {
  scratchpadBusy: boolean;
  calculatorBusy: boolean;
  exportBusy: boolean;
  onScratchpad: (enabled: boolean) => void;
  onCalculator: (enabled: boolean) => void;
  onTeacher: (action: "clone" | "share" | "reassign") => void;
  onPreview: () => void;
  onDownload: () => void;
  onDelete: () => void;
};

export const LessonActions = (props: LessonActionsProps) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button variant="outline" size="sm">Lesson actions <ChevronDown className="ml-1 size-3.5" /></Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuLabel>All slides</DropdownMenuLabel>
      <DropdownMenuItem disabled={props.scratchpadBusy} onSelect={() => props.onScratchpad(true)}>Enable scratchpad</DropdownMenuItem>
      <DropdownMenuItem disabled={props.scratchpadBusy} onSelect={() => props.onScratchpad(false)}>Disable scratchpad</DropdownMenuItem>
      <DropdownMenuItem disabled={props.calculatorBusy} onSelect={() => props.onCalculator(true)}>Enable calculator</DropdownMenuItem>
      <DropdownMenuItem disabled={props.calculatorBusy} onSelect={() => props.onCalculator(false)}>Disable calculator</DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem onSelect={() => props.onTeacher("clone")}>Clone lesson</DropdownMenuItem>
      <DropdownMenuItem onSelect={() => props.onTeacher("share")}>Grant lesson</DropdownMenuItem>
      <DropdownMenuItem onSelect={() => props.onTeacher("reassign")}>Move lesson</DropdownMenuItem>
      <DropdownMenuItem disabled={props.exportBusy} onSelect={props.onPreview}>Preview</DropdownMenuItem>
      <DropdownMenuItem disabled={props.exportBusy} onSelect={props.onDownload}>Download</DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem className="text-destructive" onSelect={props.onDelete}>Delete lesson…</DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);
